class EqualHeight {

	constructor(blockEl) {
		this.el = blockEl;
		this.targets = this.el.querySelectorAll('.equal-height-target');

		this.init();
	}

	async init() {
		const maxHeight = await this.getHeights();
		this.equalizeHeights(maxHeight);
	}
	
	async getHeights() {
		let maxHeight = 0; 
		this.targets.forEach(target => {
			const targetHeight = target.offsetHeight;
			if (targetHeight > maxHeight) {
				maxHeight = targetHeight;
			}
		});

		return maxHeight;
	}

	equalizeHeights(maxHeight) {
		this.targets.forEach(target => {
			target.style.height = maxHeight + 'px';
		});
	}

}

export default EqualHeight;